export default __webpack_public_path__ + "static/media/inline3.feb777f1.jpg";